import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import { iconBeforeLabelClass } from "../../i18n";
import {
  HEADER_MENU_ANCHOR_ORIGIN,
  HEADER_MENU_PAPER_SX,
  HEADER_MENU_TRANSFORM_ORIGIN,
} from "../../utils/headerMenuStyles";

export default function CustomPopover(props) {
  const { i18n } = useTranslation();
  const anchorRef = useRef(null);
  const { menu, data, isHorizontal } = props;
  const iconGapClass = iconBeforeLabelClass(
    i18n.resolvedLanguage || i18n.language
  );

  const [open, setOpen] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  const iconData = {
    style: { cursor: "pointer", fontSize: 20, color: "var(--portal-theme-color)" },
    className: "pointer custom-popover-icon",
    ref: anchorRef,
    onClick: handleOpen,
  };

  if (menu.length === 0) return null;

  return (
    <div
      style={{ cursor: "pointer" }}
      className="align-items-center d-flex justify-content-center z-index-999"
    >
      {isHorizontal ? (
        <MoreHorizIcon {...iconData} />
      ) : (
        <MoreVertIcon {...iconData} />
      )}

      <Menu
        className="custom-menu-popover"
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        autoFocus={false}
        disableAutoFocusItem={true}
        PaperProps={{
          elevation: 0,
          sx: {
            ...HEADER_MENU_PAPER_SX,
          },
        }}
        transformOrigin={HEADER_MENU_TRANSFORM_ORIGIN}
        anchorOrigin={HEADER_MENU_ANCHOR_ORIGIN}
      >
        {menu.map((option, index) => (
          <MenuItem
            key={option.label ?? `menu-${index}`}
            id={option.id}
            title={option.title || option.label}
            aria-label={option.ariaLabel || option.title || option.label}
            onClick={(event) => {
              event.stopPropagation();
              setOpen(false);
              option.handleClick(data);
            }}
            sx={{
              minHeight: "auto",
              display: "flex",
              alignItems: "center",
              gap: 1,
              outline: "none !important",
              border: "none !important",
              boxShadow: "none !important",
              "&:focus": {
                outline: "none !important",
                border: "none !important",
                boxShadow: "none !important",
              },
              "&:focus-visible": {
                outline: "none !important",
                border: "none !important",
                boxShadow: "none !important",
              },
              "&.Mui-focusVisible": {
                outline: "none !important",
                border: "none !important",
                boxShadow: "none !important",
              },
            }}
          >
            {option.icon && (
              <Icon
                fontSize="18"
                style={{ color: option.color || "var(--portal-theme-color)" }}
                className={iconGapClass}
                icon={option.icon}
              />
            )}
            <span
              className="custom-menu-popover-label"
              style={option.color ? { color: option.color } : {}}
            >
              {option.label}
            </span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
